import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Search } from 'lucide-react';
import classes from "./ManageCurrency.module.css"
import plus from "../../../../Assets/plus.svg"
import EyeIcon from "../../../../Assets/new-eye.svg"
import DeleteIcon from "../../../../Assets/new-delete.svg"
import PencilIcon from "../../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form, Alert } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../../Budget/Budget Dashboard/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const ManageCurrency = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [show, setShow] = useState(false);
  const [continentDescription, setContinentDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [continents, setContinents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedContinent, setSelectedContinent] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [bearer, setBearer] = useState('');
  const navigate = useNavigate();

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // You can change this number

  // Get token from localStorage - IMPROVED VERSION
  const readData = () => {
    try {
      const token = localStorage.getItem('userToken');
      console.log("Token retrieved from localStorage:", token ? "Yes" : "No");

      if (token) {
        setBearer(token);
        console.log("Token set in state successfully");
      } else {
        console.error("No authentication token found in localStorage");
        Swal.fire({
          icon: 'error',
          title: 'Authentication Required',
          text: 'Please log in to continue',
        });
        navigate('/login');
      }
    } catch (e) {
      console.error('Failed to fetch token from storage:', e);
      navigate('/login');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  // Headers function to ensure fresh token
  const getHeaders = () => {
    const token = bearer || localStorage.getItem('userToken');
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };
  };

  // Fetch continents from API
  const fetchContinents = async () => {
    try {
      setLoading(true);
      setError("");

      const token = bearer || localStorage.getItem('userToken');
      if (!token) {
        setError("Please log in to access this resource");
        setLoading(false);
        navigate('/login');
        return;
      }

      console.log("Fetching continents with token:", token ? "Available" : "Missing");

      const response = await axios.get(`${BASE_URL}/continents`, {
        headers: getHeaders()
      });

      // Handle different response structures
      if (response.data.status) {
        setContinents(response.data.data);
      } else if (Array.isArray(response.data)) {
        setContinents(response.data);
      } else if (response.data.data) {
        setContinents(response.data.data);
      } else {
        setContinents([]);
      }

      setSuccess("Continents loaded successfully");
    } catch (error) {
      console.error("Error fetching continents:", error);

      if (error.response?.status === 401) {
        setError("Session expired. Please log in again.");
        localStorage.removeItem('userToken');
        navigate('/login');
      } else if (error.response?.status === 404) {
        try {
          const response = await axios.get(`${BASE_URL}/api/continents`, {
            headers: getHeaders()
          });
          if (response.data) {
            setContinents(response.data.data || response.data);
            setSuccess("Continents loaded successfully");
            return;
          }
        } catch (secondError) {
          console.error("Second attempt failed:", secondError);
        }
        setError("Continents endpoint not found. Please check the API configuration.");
      } else if (error.response?.data?.message) {
        setError(error.response.data.message);
      } else {
        setError("Failed to load continents. Please try again.");
      }
      setContinents([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      console.log("Bearer token available, fetching continents...");
      fetchContinents();
    }
  }, [bearer]);

  // Create new continent using POST request
  const createContinent = async () => {
    if (!continentDescription.trim()) {
      setError("Please enter a continent description");
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to create this continent?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Create",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        try {
          const response = await axios.post(
            `${BASE_URL}/continents/create_continent`,
            {
              description: continentDescription
            },
            {
              headers: getHeaders()
            }
          );

          console.log("Create continent response:", response.data);

          if (response.data.status || response.data.success) {
            setSuccess("Continent created successfully");
            setContinentDescription("");
            setShow(false);
            fetchContinents(); // Refresh the list

            Swal.fire({
              title: "Success!",
              text: response.data.message || "Continent created successfully",
              icon: "success",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error("Error creating continent:", error);
          console.log("Full error object:", error);

          let errorMessage = "Something went wrong while creating the continent.";

          if (error.response?.status === 401) {
            errorMessage = "Your session has expired. Please log in again.";
            localStorage.removeItem('userToken');
            navigate('/login');
          } else if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
          } else if (error.response?.data?.error) {
            errorMessage = error.response.data.error;
          } else if (error.message === 'Network Error') {
            errorMessage = "Network error. Please check your internet connection.";
          }

          Swal.fire({
            title: "Error!",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setIsLoading(false);
        }
      }
    });
  };

  // Update continent
  const updateContinent = async () => {
    if (!continentDescription.trim() || !selectedContinent) {
      setError("Please enter a continent description");
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this continent?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Update",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        try {
          const response = await axios.post(
            `${BASE_URL}/continents/update_continent`,
            {
              id: selectedContinent.id,
              description: continentDescription
            },
            {
              headers: getHeaders()
            }
          );

          if (response.data.status || response.data.success) {
            setSuccess("Continent updated successfully");
            setShow1(false);
            setSelectedContinent(null);
            setContinentDescription("");
            fetchContinents(); // Refresh the list

            Swal.fire({
              title: "Success!",
              text: response.data.message || "Continent updated successfully",
              icon: "success",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error("Error updating continent:", error);
          let errorMessage = "Something went wrong.";
          if (error.response?.status === 401) {
            errorMessage = "Session expired. Please log in again.";
            localStorage.removeItem('userToken');
            navigate('/login');
          } else if (error.response?.data?.message) {
            errorMessage = typeof error.response.data.message === "string"
              ? error.response.data.message
              : JSON.stringify(error.response.data.message);
          }

          Swal.fire({
            title: "Error!",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setIsLoading(false);
        }
      }
    });
  };

  // Delete continent - FIXED to use DELETE method
  // Delete continent - Alternative version with manual loading state
  const deleteContinent = async (continentId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this continent?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Show loading state in SweetAlert
        Swal.fire({
          title: 'Deleting...',
          text: 'Please wait while we delete the continent',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        try {
          // Use GET request with parameters since DELETE is not supported
          const response = await axios.get(
            `${BASE_URL}/continents/delete_continent`,
            {
              params: { id: continentId },
              headers: getHeaders()
            }
          );

          if (response.data.status || response.data.success) {
            setSuccess("Continent deleted successfully");
            fetchContinents(); // Refresh the list

            Swal.fire({
              title: "Deleted!",
              text: response.data.message || "Continent deleted successfully",
              icon: "success",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error("Error deleting continent:", error);
          let errorMessage = "Something went wrong.";
          if (error.response?.status === 401) {
            errorMessage = "Session expired. Please log in again.";
            localStorage.removeItem('userToken');
            navigate('/login');
          } else if (error.response?.data?.message) {
            errorMessage = typeof error.response.data.message === "string"
              ? error.response.data.message
              : JSON.stringify(error.response.data.message);
          }

          Swal.fire({
            title: "Error!",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  const handleShow = () => {
    setShow(true);
    setContinentDescription(""); // This ensures the input is always empty when modal opens
    setError("");
  };

  const handleClose = () => {
    setShow(false);
    setError("");
  };

  const handleShow1 = (continent) => {
    setSelectedContinent(continent);
    setContinentDescription(continent.description); // This pre-fills for editing (which is correct)
    setShow1(true);
    setError("");
  };

  const handleClose1 = () => {
    setShow1(false);
    setSelectedContinent(null);
    setContinentDescription(""); // Clear input field when closing edit modal
    setError("");
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Filter continents based on search term
  const filteredContinents = continents.filter(continent =>
    continent?.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    continent?.id?.toString().includes(searchTerm)
  );

  // Get current items for pagination
  const currentContinents = filteredContinents.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredContinents.length / itemsPerPage);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Go to first page
  const goToFirstPage = () => setCurrentPage(1);

  // Go to last page
  const goToLastPage = () => setCurrentPage(totalPages);

  // Generate page numbers to display
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 2; // Show only 2 page numbers as in your design

    if (totalPages <= maxPagesToShow) {
      // Show all pages if total pages are less than or equal to maxPagesToShow
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Show current page and one adjacent page
      const startPage = Math.max(1, currentPage - 1);
      const endPage = Math.min(totalPages, currentPage + 1);

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }
    }

    return pageNumbers;
  };

  function getContinentColors(name) {
    if (!name) return { backgroundColor: '#f0f0f0', color: '#666' };

    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash) % 360;

    return {
      backgroundColor: `hsl(${hue}, 70%, 90%)`,
      color: `hsl(${hue}, 70%, 30%)`,
    };
  }

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';

    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div>
      <HeaderNav />

      {/* Create Continent Modal */}
      <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Create Continent</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form>
            <Form.Group className="mb-3">
              <Form.Label style={{ marginTop: 20 }}>Continent Description</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Continent Description"
                value={continentDescription}
                onChange={(e) => setContinentDescription(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Go back
          </Button>
          <Button
            className={classes.customButton}
            onClick={createContinent}
            disabled={isLoading || !continentDescription.trim()}
          >
            {isLoading ? (
              <>
                <Spinner size="sm" />
                <span style={{ marginLeft: "5px" }}>Creating...</span>
              </>
            ) : (
              "Create"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Update Continent Modal */}
      <Modal show={show1} onHide={handleClose1} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Update Continent</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form>
            <Form.Group className="mb-3">
              <Form.Label style={{ marginTop: 20 }}>Continent Description</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Continent Description"
                value={continentDescription}
                onChange={(e) => setContinentDescription(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose1}>
            Go back
          </Button>
          <Button
            className={classes.customButton}
            onClick={updateContinent}
            disabled={isLoading || !continentDescription.trim()}
          >
            {isLoading ? (
              <>
                <Spinner size="sm" />
                <span style={{ marginLeft: "5px" }}>Updating...</span>
              </>
            ) : (
              "Save Changes"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <div className={classes.topContainer}>
        <div className={classes.topNavBars}>
          <Button className={classes.buttonsNav}>Remitances</Button>
          <Button className={classes.buttonsNav}>Petty Cash</Button>
          <Button className={classes.buttonsNav}>Supplier's Payment</Button>
          <Button className={classes.buttonsNav}>Customer's Leger</Button>
        </div>
        <div style={{ marginTop: 24 }} />
        <h3 className={classes.topText}>Manage Continent</h3>
        <p className={classes.prgText}>Add, View, Edit, and Delete Continent.</p>

        <div className={classes.subContainer}>
          <div className={classes.searchInputWrapper}>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={classes.searchInput}
              placeholder="Search continents..."
            />
            <Search className={classes.searchIcon} size={16} />
          </div>
          <div className={classes.statCount}>
            <div className={classes.statConn}>
              <p className={classes.txtHd}>Continents</p>
              {loading ? (
                <div className={classes.skeleton} style={{ width: '40px', height: '24px', marginTop: '-10px' }}></div>
              ) : (
                <p className={classes.txtHds}>{continents.length}</p>
              )}
            </div>
          </div>
          <div>
            <button className={classes.loanBtn} onClick={handleShow}>
              <img src={plus} alt="plus" /> Add New Continent
            </button>
          </div>
        </div>

        <div className={classes.tableContainer}>
          {loading ? (
            <div className="text-center p-4">
              <Spinner animation="border" variant="primary" />
              <p>Loading continents...</p>
            </div>
          ) : (
            <>
              <table className={classes.tableTable}>
                <thead className={classes.tableHeader}>
                  <tr>
                    <th>#</th>
                    <th>Continent</th>
                    <th>Created At</th>
                    <th>Updated At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentContinents.length > 0 ? (
                    currentContinents.map((continent, index) => (
                      <tr key={continent.id || index}>
                        <td className={classes.textby}>{indexOfFirstItem + index + 1}</td>
                        <td className={classes.textby}>
                          <span className={classes.statucColor}>
                            {continent.description || 'N/A'}
                          </span>
                        </td>
                        <td className={classes.textby}>
                          {formatDate(continent.created_at)}
                        </td>
                        <td className={classes.textby}>
                          {formatDate(continent.updated_at)}
                        </td>
                        <td className={classes.btnAction}>
                          <button
                            style={{ backgroundColor: "transparent", border: 0, cursor: "pointer", marginRight: '10px' }}
                            onClick={() => handleShow1(continent)}
                            title="View/Edit"
                          >
                            <img src={EyeIcon} alt="View" />
                          </button>
                          <button
                            style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
                            onClick={() => deleteContinent(continent.id)}
                            title="Delete"
                          >
                            <img src={DeleteIcon} alt="Delete" />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center p-4">
                        {searchTerm ? "No continents found matching your search" : "No continents available"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Pagination */}
              <div className={classes.paginationStyle}>
                <div className={classes.footerSubOne}>
                  <button
                    className={classes.btnFirst}
                    onClick={goToFirstPage}
                    disabled={currentPage === 1}
                  >
                    First
                  </button>
                  <span className={classes.ftOne}>
                    {getPageNumbers().map(number => (
                      <button
                        key={number}
                        className={`${classes.pageNumber} ${currentPage === number ? classes.active : ''}`}
                        onClick={() => paginate(number)}
                      >
                        {number}
                      </button>
                    ))}
                  </span>
                  <button
                    className={classes.btnSec}
                    onClick={goToLastPage}
                    disabled={currentPage === totalPages}
                  >
                    Last
                  </button>
                </div>
                <p className={classes.displayPag}>
                  Displaying {indexOfFirstItem + 1}-{Math.min(indexOfLastItem, filteredContinents.length)} of {filteredContinents.length}
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default ManageCurrency